import { useWindowSize } from "@/hooks/useIsMobile";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

const TabComponent = ({ liveTV_id }) => {
  const router = useRouter();

  const tabs = [
    { id: "livetv-at", label: "Aajtak", url: "/aajtak-livetv" },
    { id: "livetv-it", label: "India Today", url: "/indiatoday-livetv" },
    { id: "livetv-gnt", label: "GNT GNTV", url: "/good-news-today-livetv" },
  ];
  const [activeTab, setActiveTab] = useState(liveTV_id || "livetv-at");
  // Sync URL with the active tab
  useEffect(() => {
    const currentTab = tabs.find((tab) => tab.id === activeTab);
    if (currentTab && router.pathname !== currentTab.url) {
      router.push(currentTab.url, undefined, { shallow: true });
    }
  }, [activeTab, router]);
  const size = useWindowSize();
  let height;
  if (size.width > 1024) {
    height = "454"; // Desktop
  } else if (size.width > 720 && size.width <= 1024) {
    height = "420"; // Tablet
  } else {
    height = "220"; // Mobile
  }

  return (
    <div className="max-w-4xl mx-auto mt-2 font-sans">
      <div className="flex   border-gray-300 bg-gray-100 rounded-t-md overflow-hidden">
        {tabs.map((tab) => (
          <a
            href={process.env.NEXT_PUBLIC_WEBSITE_URL + tab.url}
            key={tab.id}
            onClick={(e) => {
              // e.preventDefault(); // Prevent default anchor behavior/
              setActiveTab(tab.id);
            }}
            className={`flex-1 py-3  px-4 font-semibold text-center cursor-pointer transition-all duration-300
              ${
                activeTab === tab.id
                  ? "bg-red-500 text-white border-red-500 shadow border-r-0 border-2"
                  : "bg-white text-gray-700 hover:bg-gray-200 border-2"
              }
            `}
          >
            {tab.label}
          </a>
        ))}
      </div>

      {/* Tab Content */}

      {tabs.map(
        (tab) =>
          activeTab === tab.id && (
            <iframe
              key={tab.id}
              title={tab.label}
              className="  shadow-md"
              allowFullScreens
              id={`livetv-${tab.id}`}
              width={"100%"}
              height={height}
              src={`https://feeds.intoday.in/livetv/ver-3-0/?id=${tab.id}&aud_togle=1&autostart=1&mute=1&t_src=live_tv_page&t_med=web&utm_medium=web&utm_source=live_tv_page`}
              scrolling="no"
              frameBorder="0"
              allow="accelerometer; autoplay; fullscreen; clipboard-write; encrypted-media; gyroscope"
              mozallowfullscreen
              webkitallowfullscreen
            ></iframe>
          )
      )}
    </div>
  );
};

export default TabComponent;
